import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentsListComponent } from './payments-list.component';
import { CtButtonModule, CtModelModule } from '@ctsolution/ct-framework';

@NgModule({
  imports: [
    CommonModule,
    CtModelModule,
    CtButtonModule
  ],
  declarations: [PaymentsListComponent],
  exports : [PaymentsListComponent]
})
export class PaymentsListModule { }
